import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../Personal Attendance/useAuth";

// ---------------------------------------------------------------------------
// src/pages/KPI/KpiHubRouteGuard.js
//
// Route guard for the KPI / Reports hub (/kpi). PURE PERMISSION model: access
// requires a KPI permission — "KPI - View Hub", a category perm, or a specific
// report perm. Only IT Admin bypasses (unconditional super-user). No KPI
// permission means no hub, even for a President / supervisor. Per-card gating
// in reportConfig still applies, so a user sees only the cards their grants
// allow. (dept.kpi is itself now pure-permission in EffectiveAccessService.)
// ---------------------------------------------------------------------------

const KPI_PERMS = [
    "KPI - View Hub",
    "KPI - Finance Reports",
    "KPI - Sales Reports",
    "KPI - Inventory Reports",
    "KPI - Orders Reports",
    "KPI - Quality Reports",
    "KPI - Vendor Reports",
    "KPI - Planning Reports",
    "KPI - X-Ray Report",
    "KPI - Aged Receivables",
    "KPI - Aged Payables",
    "KPI - Variance Report",
];

const KpiHubRouteGuard = ({ children }) => {
    const auth = useAuth();

    const hasAnyKpiPerm =
        typeof auth.hasAccess === "function" &&
        KPI_PERMS.some((p) => auth.hasAccess(p));

    const allowed =
        auth.isItAdmin ||
        (typeof auth.canAccessModule === "function" && auth.canAccessModule("dept.kpi")) ||
        hasAnyKpiPerm;

    if (!allowed) return <Navigate to="/access-denied" replace />;
    return <>{children}</>;
};

export default KpiHubRouteGuard;
